<template>
    <div class="border-b border-uiMidGrey last:border-none">
        <button
            type="button"
            class="flex items-center gap-x-2 w-full pt-5 pb-4 box-border"
            :aria-label="`${filterTranslation} (${filtersActive} ${$root.config.translations.filters.selected})`"
            @click.prevent="toggleAccordion()"
        >
            <span class="body-m font-bold">
                {{ filterTranslation }}
            </span>
            <span
                class="block ml-auto transition-transform duration-300 transform [&.is-active]:-scale-y-100"
                :class="{'is-active': accordionActive}"
            >
                <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M-0.000372908 1.00037C-0.000372903 0.870372 0.0496273 0.740372 0.159627 0.640372C0.359627 0.450372 0.679627 0.460372 0.869627 0.660372L6.50963 6.60037L12.1396 0.660372C12.3296 0.460372 12.6396 0.450373 12.8396 0.640373C13.0396 0.830373 13.0496 1.15037 12.8596 1.35037L6.85963 7.68037C6.76963 7.78037 6.62963 7.84037 6.49963 7.84037C6.36963 7.84037 6.22963 7.78037 6.13963 7.68037L0.139627 1.34037C0.0496273 1.24037 -0.000372914 1.12037 -0.000372908 1.00037Z" />
                </svg>
            </span>
        </button>
        <div :class="{'hidden': !accordionActive}">
            <fieldset>
                <legend class="sr-only">
                    {{ filterTranslation }}
                </legend>
            </fieldset>
            <ul class="grid grid-cols-1 gap-[0.375rem] mb-5">
                <li
                    v-for="(filter, index) in filterData"
                    :key="index"
                    class="col-span-1"
                >
                    <label
                        class="box-border relative z-0 flex py-[0.5625rem] px-[1.125rem] h-full cursor-pointer group"
                        :class="{ 'opacity-50 pointer-events-none': filter.count === 0 }"
                        :for="`Filter-${filterId}-${filter.value}`"
                    >
                        <input
                            :id="`Filter-${filterId}-${filter.value}`"
                            class="peer appearance-none"
                            type="checkbox"
                            :name="filter.value"
                            :value="filter.value"
                            v-model="filter.checked"
                            :data-type="filterType"
                            :data-label="filter.label"
                        >
                        <span
                            class="
                                absolute top-0 left-0 -z-10 w-full h-full border rounded-sm transition-colors duration-300 border-uiDarkGrey bg-transparent
                                peer-focus-keyboard:outline peer-checked:border-primary peer-checked:bg-primary
                                group-hover:border-primary group-hover:bg-uiMidGrey"
                        >
                        </span>
                        <span class="block text-body-s transition-colors duration-300 peer-checked:text-text2 group-hover:text-primary">
                            {{ filter.label }} ({{ filter.count }})
                        </span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            filterData: {
                type: Array,
                default() {
                    return [];
                }
            },
            filterId: {
                type: String,
                default() {
                    return '';
                }
            },
            filterTranslation: {
                type: String,
                default() {
                    return '';
                }
            },
            filterType: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data () {
            return {
                accordionActive: true
            }
        },
        computed: {
            filtersActive () {
                return this.filterData.filter(filter => filter.checked === true).length;
            }
        },
        methods: {
            toggleAccordion () {
                this.accordionActive = !this.accordionActive;
            }
        }
    }
</script>
